export function getWindow() {
  return window;
}
